"use client";

import TailwindLoading from "./tailwind-loading";

interface LottieLoadingProps {
  size?: "sm" | "md" | "lg" | number;
  className?: string;
}

const LottieLoading: React.FC<LottieLoadingProps> = ({ size = "sm", className = "" }) => {
  // Convert number size to string size
  let tailwindSize: "sm" | "md" | "lg" = "md";

  if (typeof size === "number") {
    if (size <= 40) tailwindSize = "sm";
    else if (size <= 80) tailwindSize = "md";
    else tailwindSize = "lg";
  } else {
    tailwindSize = size;
  }

  return <TailwindLoading size={tailwindSize} variant="multicolor" className={className} />;
};

export default LottieLoading;
